import globalAxios from "axios";
import { ConfigJson } from "./config-json.ts";

export default function configureAxios({
  BASE_URL_API_GATEWAY,
}: ConfigJson): void {
  globalAxios.defaults.baseURL = BASE_URL_API_GATEWAY ?? "/api";
  globalAxios.defaults.withCredentials = true;
}
